import { render, staticRenderFns } from "./mc-serving-line-summary.vue?vue&type=template&id=10944f31&scoped=true"
import script from "./mc-serving-line-summary.vue?vue&type=script&lang=ts"
export * from "./mc-serving-line-summary.vue?vue&type=script&lang=ts"
import style0 from "./mc-serving-line-summary.vue?vue&type=style&index=0&id=10944f31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10944f31",
  null
  
)

export default component.exports